export default {
      id: "chevrons-alu-usage",
      viewBox: "0 0 175 350",
      url: "../dist/images/" + "sprite.svg#chevrons-alu-usage",
      toString: function () {
        return this.url;
      }
    }